import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { MENU_LAYOUT_ID } from 'constants/layout';
import BaseLayout from 'bento-ordering/base/layouts/BaseLayout';

const MenuLayout = ({ children, heroImage, isFetching }) => (
  <BaseLayout
    heroImage={heroImage}
    isFetching={isFetching}
    id={MENU_LAYOUT_ID}
    shouldUseMenuStyle
  >
    {children}
  </BaseLayout>
);

MenuLayout.propTypes = {
  children: PropTypes.object,
  heroImage: PropTypes.object,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => {
  const image = get(state.menu, 'images[0]', {});
  return {
    isFetching: state.menu.isFetching,
    heroImage: image
  };
};

export default connect(mapStateToProps)(MenuLayout);
